// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
/* eslint-disable @typescript-eslint/triple-slash-reference */
/// <reference path="../../.env.d.ts" />

export const environment = {
    production: false,
    apiUrl: import.meta.env['NG_APP_API_URL'],
    website: import.meta.env['NG_APP_WEBSITE_URL'],
    webappUrl: import.meta.env['NG_APP_WEBAPP_URL'],
    tokenKey: 'token_pro',
    googleMapsApiKey: import.meta.env['NG_APP_GOOGLE_API_KEY'],
    googleMapsId: import.meta.env['NG_APP_GOOGLE_MAPS_ID'],
    analytics: {
        googleAnalyticsId: import.meta.env['NG_APP_GOOGLE_ANALYTICS_ID'],
        googleTagManagerId: import.meta.env['NG_APP_GTM_ID'],
        mixpanelToken: import.meta.env['NG_APP_MIXPANEL_API_KEY'],
        enableGoogleAnalytics: false,
        enableMixpanelAnalytics: false
    },
    isDev: import.meta.env['NG_APP_IS_DEV'] === 'true' ? true : false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
